module.exports = __webpack_public_path__ + "img/demo-01-slide-2.6b53ea9f.jpg";